module.exports = __webpack_public_path__ + "img/DE01094.a3c8fb71.png";